/**
 * File Name          : byte-helpers.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */


export function Uint8Bytes(value: number): Uint8Array {
    var output = new Uint8Array(1)
    output[0] = (value & 0xFF) 
    return output
}

export function Uint16Bytes(value: number): Uint8Array {
    var output = new Uint8Array(2)

    output[0] = (value & 0xFF)
    output[1] = ((value >>8) & 0xFF)

    return output
}

export function Uint32Bytes(value: number): Uint8Array {
    var output = new Uint8Array(4)

    output[0] = (value & 0xFF)
    output[1] = ((value >>8) & 0xFF)
    output[2] = ((value >>16) & 0xFF)
    output[3] = ((value >>24) & 0xFF)

    return output
}
export function Uint64Bytes(value: number): Uint8Array {
    var output = new Uint8Array(4)

    output[0] = (value & 0xFF)
    output[1] = ((value >>8) & 0xFF)
    output[2] = ((value >>16) & 0xFF)
    output[3] = ((value >>24) & 0xFF)
    output[4] = ((value >>32) & 0xFF)
    output[5] = ((value >>40) & 0xFF)
    output[6] = ((value >>48) & 0xFF)
    output[7] = ((value >>56) & 0xFF)

    return output
}

export function Int8Bytes(value: number): Uint8Array {
    return Uint8Bytes(value)
}

export function Int16Bytes(value: number): Uint8Array {
    return Uint16Bytes(value)
}

export function Int32Bytes(value: number): Uint8Array {
    return Uint32Bytes(value)
}

export function Int64Bytes(value: number): Uint8Array {
    return Uint64Bytes(value)
}

export function float32Bytes(value: number): Uint8Array {
    let buffer = new ArrayBuffer(4); // Float32 is 4 bytes long
    let view = new DataView(buffer);
    view.setFloat32(0, value, true); // The last parameter indicates little-endian byte order
    return new Uint8Array(buffer);
}

export function float64Bytes(value: number): Uint8Array {
    let buffer = new ArrayBuffer(8); // Float64 is 8 bytes long
    let view = new DataView(buffer);
    view.setFloat64(0, value, true); // The last parameter indicates little-endian byte order
    return new Uint8Array(buffer);
}